import React from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Icon, H5, S } from 'design-system-web';
import {simpleDateTime, WorkOrderAttachment} from '../../utils/WorkOrder';
import styles from './AttachmentModal.scss';

export type attachmentProps = WorkOrderAttachment & {
  error?: boolean;
  errorMessage?: string;
  onDelete: (
    fileId?: string | number,
    fileAssociationId?: string
  ) => Promise<void>;
  testId?: string;
  loading?: boolean;
};

export function Attachment({
  id,
  file_association_id,
  display_name,
  thumbnail,
  created_at,
  error = false,
  errorMessage,
  onDelete,
  testId,
  loading = false,
}: attachmentProps) {
  const { t } = useTranslation();

  return (
    <div className={cx(styles.attachment, { [styles.error]: error })}>
      {loading && (
        <div className={cx(styles.imageOutline)}>
        <Icon name="circle-notch" className={styles.spinnerIcon} />
        </div>
      )}
      {!error && id && !loading && (
        <div className={cx(styles.imageOutline)}>
          {thumbnail && (
            <img src={thumbnail} className={cx(styles.image)} alt="thumbnail" />
          )}
          {!thumbnail && <Icon name="file" className={styles.docIcon} />}
        </div>
      )}
      {error && (
        <div className={cx(styles.errorImageOutline)}>
          <Icon name="exclamation-circle" className={styles.errorIcon} />
        </div>
      )}
      <div className={cx(styles.textAndClose)}>
        <div className={cx(styles.content)}>
          <H5 className={cx(styles.displayName)}>{display_name}</H5>
          {error && <S className={styles.errorMessage}>{errorMessage || t('shared.integrations.vantify.workorder.attachment.fail')}</S>}
          {!error && id && (
            <>
              {created_at ? simpleDateTime(created_at) : ''}
            </>
          )}
        </div>
          <button
            data-test={testId}
            className={styles.close}
            onClick={() => onDelete(id, file_association_id)}
            type="button"
          >
            <Icon name="times" className={styles.closeIcon} />
          </button>
      </div>
    </div>
  );
}